import React, { Component , useEffect } from 'react'
import { AiFillStar } from "react-icons/ai";
import { BsFillClockFill } from "react-icons/bs";
import { IoIosPeople } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { SiGotomeeting } from "react-icons/si";
import { FaPlus } from "react-icons/fa6";
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";


function About_total_Count({ interval }) {
    // useEffect(() => {
    //   const valueDisplays = document.querySelectorAll(".num");
      
    //   valueDisplays.forEach((valueDisplay) => {
    //     const startValue = 0;
    //     const endValue = parseInt(valueDisplay.getAttribute("data-val"), 10);
    //     const duration = Math.floor(interval / endValue);
        
    //     let current = startValue;
    //     const counter = setInterval(function () {
    //       current += 1;
    //       valueDisplay.textContent = current;
    //       if (current === endValue) {
    //         clearInterval(counter);
    //       }
    //     }, duration);
  
    //     // Cleanup the interval when the component unmounts
    //     return () => clearInterval(counter);
    //   });
    // }, [interval]);
  
    return (
      <div className='Total_count_background'>
        {/* ---------------------------Mobile View------------------------- */}
        <div className='d-sm-block pb-5 pt-4 d-md-none'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
              <span className="mb-4 display-5 mobile_total_component_text">Success Stats</span>
              <p className=" pt-3 mobile_total_component_text_p">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
          </MDBCol>
          </MDBRow>
          <div className='container-fluid'>
            <div className='row'>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num" data-val="40">40</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon1' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Programs</p></div>
            </div>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num_houre" data-val="100">100</p></div>
            </div>
            <div><p class="mobile_text">Hours</p></div>
            </div>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num" data-val="50">50</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon4' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Mentors</p></div>
            </div>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num" data-val="100">100</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon5' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Recruiters</p></div>
            </div>
            <div class="col-12 pt-2">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num_student" data-val="10000">10K</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon3' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Students</p></div>
            </div>
            </div>
          </div>
          </div>
        </div>

        {/* ---------------------------Dasktop View------------------------- */}
        <div className='pt-5 d-none d-md-block'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
              <span className="mb-4 display-4 total_component_text">Success Stats</span>
              <p className=" pt-3">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
          </MDBCol>
          </MDBRow>
          </div>
          <div class="wrapper pb-5">
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="40">40</p></div>
                <div className=''><FaPlus  className='Total_box_icon1' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Programs</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="100">100</p></div>
              </div>
              <div><p class="text">Hours</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="10000">10K</p></div>
                <div className=''><FaPlus  className='Total_box_icon3' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Students</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="50">50</p></div>
                <div className=''><FaPlus  className='Total_box_icon4' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Mentors</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="100">100</p></div>
                <div className=''><FaPlus  className='Total_box_icon5' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Recruiters</p></div>
          </div>
          
          </div>
        </div>
      </div>
    );
  }
  
  export default About_total_Count;


